export const GROMART_URL = process.env.REACT_APP_GROMART_URL;
export const GROCHAT_URL = process.env.REACT_APP_GROCHAT_URL;
export const GROLOG_URL = process.env.REACT_APP_GROLOG_URL + 'manager/v1/grolog';
export const GROLOG_URL_DEV = 'http://app.sbp:9005/v1/grolog';
export const TOKEN = `eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJjaWQiOiIyYWM3ZjM5MGUzYjk0ODg3ODQ4NjkxMzViZDliNjI3OCIsInJlc291cmNlIjoiY2hhdCBkcml2ZSBsb2ciLCJzY29wZSI6InJlYWQgd3JpdGUiLCJsb2NhbGUiOiJpZC1JRCIsImV4cCI6MTY4MTQ2MzM1OSwianRpIjoiYzgzODM4M2IyOTczNGM3MTg2MjdiYWRhOWNhOTYwNjciLCJpYXQiOjE2ODEzNzY5NTksInN1YiI6IjQ4NjkyOCJ9.Bf6ZIvJEDIpOKH71Ce2hIgxYGCjmaa5D5vHfHj10w5vgjMEG4bW67lbY92nXi7LRxb9wLCrR080ENDK1JKq8cQ`
export const GROLOG_AUTH = process.env.REACT_APP_GROLOG_URL + 'auth';
// export const BASE_URL = `https://staging-grolog.gromart.club`;
// export const BASE_URL = `http://app.sbp:9005/`;
// export const REDIRECT_URI_PWA = `https://staging-grolog.gromart.club`;
export const REDIRECT_URI_PWA = `http://localhost:3000`;
export const BASE_URL = process.env.REACT_APP_GROLOG_URL_BASE;
// export const REDIRECT_URI_PWA = `https://staging-grolog.gromart.club`;
// export const REDIRECT_URI_PWA = `http://localhost:3000`;
// export const REDIRECT_URI_PWA = `https://staging-log.grocloud.id`
export const FIXED_TOKEN = "TOKEN@TEST2023";
export const GROLOG_BASE_URL = process.env.REACT_APP_GROLOG_URL;
export const GROLOG_ORDER_URL = process.env.REACT_APP_GROLOG_URL + 'order/v1/grolog';
export const GROLOG_DR_URL = process.env.REACT_APP_GROLOG_URL + 'dashboard-report/v1/grolog';
